import clsx from 'clsx';

/**
 * Shared style tokens for form field components (Input, Select, and future form atoms).
 * Each component's styles.ts should import and spread these, then add component-specific overrides.
 */
export const formFieldStyles = {
  label: 'tw-block tw-text-xs tw-font-medium tw-text-neutral-500 tw-mb-1',

  requiredIndicator: 'tw-text-danger-500 tw-ml-0.5',

  base: clsx(
    'tw-w-full tw-rounded tw-border tw-bg-white tw-text-neutral-900',
    'tw-text-sm tw-leading-tight',
    'tw-transition-colors tw-duration-150',
  ),

  focus: 'focus:tw-outline-none focus:tw-border-primary-400',

  error: 'tw-border-danger-400 focus:tw-border-danger-500',

  defaultBorder: 'tw-border-neutral-300 hover:tw-border-neutral-400',

  disabled: 'tw-bg-neutral-50 tw-text-neutral-400 tw-cursor-not-allowed tw-border-neutral-200',

  fieldIcon: 'tw-h-3.5 tw-w-3.5 tw-text-primary-500',

  errorMessage: 'tw-mt-1 tw-text-xs tw-text-danger-600',

  hint: 'tw-mt-1 tw-text-xs tw-text-neutral-400',
};
